import { html } from "lit-html"
import { facebookUrl, twitterUrl } from "../utils"

const SocialLinks = ({ url }) => html`
  <a
    class="dropdown-item"
    href=${facebookUrl(url)}
    target="_blank"
    rel="noopener noreferrer"
    role="menuitem"
  >
    Share on Facebook
  </a>
  <a
    class="dropdown-item"
    href=${twitterUrl(url)}
    target="_blank"
    rel="noopener noreferrer"
    role="menuitem"
  >
    Share on Twitter
  </a>
`

export default SocialLinks
